interface ClassItem {
    courseTitle: string;
    endDate: string;
    uploadFile: string;
    classId: string;
    startDate: string;
    status: string;
    instructor: string;
    location: string;
    classStartDate: string;
    classEndDate: string;
    hasClassStarted?: string;
}

interface ScheduledClassItem {
    courseTitle: string;
    classId: string;
    classStartDate: string;
    classEndDate: string;
    hasClassStarted: string;
}

export const getFilteredClasses = (classes: ClassItem[], searchTerm: string): ClassItem[] => {
    // if the searchTerm is empty - return all classes
    if (!searchTerm) {
        return classes;
    }

    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const searchFields: (keyof ClassItem)[] = ['classId', 'courseTitle', 'instructor', 'location'];

    const matchesSearchTerm = (classItem: ClassItem): boolean => {
        return searchFields.some((field) => {
            const fieldValue = classItem[field];

            return typeof fieldValue === 'string' && fieldValue.toLowerCase().includes(lowerCaseSearchTerm);
        });
    };

    return classes.filter(matchesSearchTerm);
};

export const getFilteredScheduledClasses = (classes: ScheduledClassItem[], searchTerm: string): ScheduledClassItem[] => {
    // if the searchTerm is empty - return all classes
    if (!searchTerm) {
        return classes;
    }

    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const searchFields: (keyof ScheduledClassItem)[] = ['classId', 'courseTitle'];

    const matchesSearchTerm = (classItem: ScheduledClassItem): boolean => {
        return searchFields.some((field) => {
            const fieldValue = classItem[field];

            return typeof fieldValue === 'string' && fieldValue.toLowerCase().includes(lowerCaseSearchTerm);
        });
    };

    return classes.filter(matchesSearchTerm);
};
